import React from "react";
import { ACTIONS } from "../../../../constants/Constants";
import { Checkbox } from "@fluentui/react";

const ConfigureClientAccess = (props) => {
  return (
    <div className="tab-section">
      <section className="sectionA">
        <p
          style={{
            fontSize: "20px",
            fontWeight: "600",
            padding: "0px 0px",
            marginBottom: "20px",
          }}
        >
          Clients
        </p>
      </section>
      {props.action === ACTIONS.VIEW && (
        <>
          {props.hospitalCheckList.length > 0 ? (
            <div className="ms-Grid-row" dir="ltr">
              <div
                className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12"
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  marginBottom: "20px",
                }}
              >
                <span>Selected Clients : </span>
              </div>
              {props.firmListForProviders.map((client, index) => {
                return (
                  <>
                    {props.hospitalCheckList.includes("" + client.id) && (
                      <div
                        key={index}
                        className="checkbox-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl4"
                      >
                        <span>{client.name}</span>
                        {/* <div
                      className="ms-sm12 ms-md8 ms-lg6 ms-xl10"
                      style={{
                        display: "block",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      <Checkbox
                        key={client.id}
                        label={client.name}
                        name={client.name}
                        styles={{
                          root: {
                            backgroundColor: "inherit !important",
                          },
                        }}
                        disabled
                        checked={props.hospitalCheckList.includes(
                          "" + client.id
                        )}
                      />
                    </div> */}
                      </div>
                    )}
                  </>
                );
              })}
            </div>
          ) : (
            <span>No clients selected</span>
          )}
        </>
      )}
      {props.action === ACTIONS.EDIT && (
        <>
          <div className="ms-Grid-row" dir="ltr">
            <div className="checkbox-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl4">
              <div
                className="ms-sm12 ms-md8 ms-lg6 ms-xl10"
                style={{
                  display: "block",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                <Checkbox
                  key={"all"}
                  label={"Select All"}
                  name={"Select all"}
                  styles={{
                    root: {
                      backgroundColor: "inherit !important",
                    },
                  }}
                  checked={
                    props.hospitalCheckList.length ===
                    props.firmListForProviders.length
                  }
                  onChange={(e, checked) => {
                    if (checked) {
                      let tempCheckedHospitalList =
                        props.firmListForProviders.map(
                          (client) => "" + client.id
                        );
                      props.setHospitalCheckList([]);
                      props.setHospitalCheckList(tempCheckedHospitalList);
                    } else {
                      props.setHospitalCheckList([]);
                    }
                  }}
                />
              </div>
            </div>
          </div>
          <div className="ms-Grid-row" dir="ltr">
            {props.firmListForProviders.map((client, index) => {
              return (
                <>
                  <div
                    key={index}
                    className="checkbox-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl4"
                  >
                    <div
                      className="ms-sm12 ms-md8 ms-lg6 ms-xl10"
                      style={{
                        display: "block",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      <Checkbox
                        key={client.id}
                        label={client.name}
                        name={client.name}
                        styles={{
                          root: {
                            backgroundColor: "inherit !important",
                          },
                        }}
                        checked={props.hospitalCheckList.includes(
                          "" + client.id
                        )}
                        onChange={(e, checked) => {
                          if (checked) {
                            let tempCheckedHospitalList =
                              props.hospitalCheckList;
                            tempCheckedHospitalList =
                              tempCheckedHospitalList.filter(
                                (id) => id != client.id
                              );
                            tempCheckedHospitalList.push("" + client.id);
                            props.setHospitalCheckList(tempCheckedHospitalList);
                          } else {
                            let tempCheckedHospitalList =
                              props.hospitalCheckList;
                            tempCheckedHospitalList =
                              tempCheckedHospitalList.filter(
                                (id) => id != client.id
                              );
                            props.setHospitalCheckList(tempCheckedHospitalList);
                          }
                        }}
                      />
                    </div>
                  </div>
                </>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};

export default ConfigureClientAccess;
